<template>
    <div>
        <Dialog v-bind:value="value" @input="$emit('input', $event)"
                title="Seite löschen ?"
                @ok="submit" ok-text="Endgültig Löschen"
                :loading="loading"
                @click:outside="close"
                @cancel="close"
        >
            Soll die Seite <b>{{ siteName }}</b>
            wirklich unwiderruflich gelöscht werden? <br><br>

            Danach kann die Seite <b>nicht wiederhergestellt</b> werden.
        </Dialog>
        <Snackbar v-model="successSnackbar" color="success">Seite <b> {{ name }} </b> erfolgreich gelöscht.
        </Snackbar>
    </div>
</template>

<script>
import Dialog from "../../../components/Dialog";
import Snackbar from "../../../components/Snackbar";

export default {
    name: "DeleteSiteDialog",
    components: {Snackbar, Dialog},
    props: ['value'],
    data: () => {
        return {
            name: null,
            successSnackbar: false,
            loading: false,
        }
    },
    computed: {
        vuexState() {
            return this.$store.state.display;
        },
        selectedSite() {
            return this.$store.state.settings.selectedItem;
        },
        siteName() {
            return this.selectedSite ? this.selectedSite.Name : '';
        }
    },
    methods: {
        async submit() {
            this.loading = true;
            let data = await this.$store.dispatch('settings/deleteSite', this.getBody());
            this.loading = false;
            if (data.Status) {
                this.successSnackbar = true;
                this.$emit('input', false); // set v-model to false -> close dialog
            } else {
                this.$root.$emit('snackbar', 'Error: Fehler beim Löschen', 'error');
            }
        },
        getBody() {
            return {
                site_id: this.selectedSite.SiteId,
                publisher_id: this.selectedSite.PublisherId,
            }
        },
        close() {
            this.$store.commit('settings/resetSelected');
            this.$emit('input', false);
        }
    },
    watch: {
        selectedSite() {
            if (this.selectedSite !== null) {
                this.name = this.selectedSite.Name;
            }
        }
    }
}
</script>

<style scoped>

</style>